import request from '../utils/request'

/**
 * 获取用户列表
 */
export function getUserList(params) {
  return request({
    url: '/admin/sys-user/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取用户详情
 */
export function getUserById(id) {
  return request({
    url: `/admin/sys-user/${id}`,
    method: 'get'
  })
}

/**
 * 创建用户
 */
export function createUser(data) {
  return request({
    url: '/admin/sys-user',
    method: 'post',
    data
  })
}

/**
 * 更新用户
 */
export function updateUser(data) {
  return request({
    url: '/admin/sys-user',
    method: 'put',
    data
  })
}

/**
 * 更新用户状态
 */
export function updateUserStatus(id, status) {
  return request({
    url: `/admin/sys-user/${id}/status`,
    method: 'put',
    params: { status }
  })
}

/**
 * 重置用户密码
 */
export function resetPassword(id, newPassword) {
  return request({
    url: `/admin/sys-user/${id}/password`,
    method: 'put',
    params: { newPassword }
  })
}


/**
 * 获取企业列表（用于下拉框）
 */
export function getCompanyList() {
  return request({
    url: '/admin/sys-user/companies',
    method: 'get'
  })
}

